import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IMapEvvEmployeeToTimeeroUser {
  employeeId: string;
  userId: string;
}

const mapEvvEmployeeToTimeeroUser = ({ employeeId, userId }: IMapEvvEmployeeToTimeeroUser) => {
  return http().put(
    endpoints.evv.mapEmployeeToTimeeroUser.replace('{employeeId}', employeeId).replace('{userId}', userId),
    {}
  );
};

export function useMapEvvEmployeeToTimeeroUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mapEvvEmployeeToTimeeroUser,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchPaginatedEvvEmployees'] });
      }
    },
  });
}
